export default class HomeHero {
  constructor(el) {
    this.$el = el;
    this.$playBtn = this.$el.querySelector(".hero__video-button");
    this.$popup = this.$el.querySelector(".hero__popup");
    this.$closePopup = this.$el.querySelector(".hero__popup-close");
    this.$backdropPopup = this.$el.querySelector(".hero__popup-backdrop");
    this.$videoPlaceholder = this.$el.querySelector(".hero__video-placeholder");
    this.$video = this.$el.querySelector(".hero__popup-video");
    if (!this.$video || !this.$videoPlaceholder) return;

    this.masterTL = this.getTimeline();

    this.$playBtn.addEventListener("click", () => {
      this.updateVideoSources(); // Call the method to update video sources
      this.masterTL.play();
    });

    this.$closePopup.addEventListener("click", () => {
      this.masterTL.reverse();
    });

    this.$backdropPopup.addEventListener("click", () => {
      this.masterTL.reverse();
    });
  }

  getTimeline() {
    const tl = gsap.timeline({
      paused: true,
      defaults: {
        ease: "power4.inOut",
        duration: 0.4,
      },
      onComplete: () => {
        // Ensure the video is loaded before attempting to play
        this.$video.load();
        this.$video.play();
        console.log("on complete");
      },
      onReverseComplete: () => {
        this.$video.pause();
        console.log("stop video");
      },
    });

    // Animate backdrop and video popup
    tl.set(this.$popup, {
      display: "flex",
    });
    tl.fromTo(
      this.$backdropPopup,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
      },
      "a"
    );
    tl.fromTo(
      this.$video,
      {
        opacity: 0,
        scale: 0.95,
      },
      {
        opacity: 1,
        scale: 1,
      },
      "a"
    );
    tl.fromTo(
      this.$closePopup,
      {
        opacity: 0,
        yPercent: -100,
      },
      {
        opacity: 1,
        yPercent: 0,
      },
      "a"
    );

    return tl;
  }

  updateVideoSources() {
    // Find all source elements within the big video
    const sources = this.$video.querySelectorAll("source");
    // Update the src attribute from data-src for each source
    sources.forEach((source) => {
      const videoSrc = source.getAttribute("data-src");
      if (videoSrc) {
        source.src = videoSrc;
      }
    });
  }
}
